// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedNewsSection_container__iNIZC","newsCard":"FeaturedNewsSection_newsCard__kW6tG"};